
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[product]",
      function () {
        return require("private-next-pages/product/[product].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[product]"])
      });
    }
  